export const dataProducts = [
    {
    id: 1,
    brand: "Dior",
    name: "BACKSTAGE Eyeshadow Palette",
    searchTerm: "eye",
    price: 49,
    image: "https://www.sephora.com/productimages/sku/s2087781-main-zoom.jpg?imwidth=230"
    },
    {
    id: 2,
    brand: "Rare Beauty by Selena Gomez",
    name: "Kind Words Matte Lipstick",
    searchTerm: "lip",
    price: 20,
    image: "https://www.sephora.com/productimages/sku/s2589422-main-zoom.jpg?imwidth=230"
    },
    {
    id: 3,
    brand: "Urban Decay",
    name: "Vice Hydrating Lipstick",
    searchTerm: "lip",
    price: 21,
    image: "https://www.sephora.com/productimages/sku/s2481943-main-zoom.jpg?imwidth=230"
    },
    {
    id: 4,
    brand: "NARS",
    name: "Powermatte Long-Lasting Lipstick",
    searchTerm: "lip",
    price: 34,
    image: "https://www.sephora.com/productimages/sku/s2599108-main-zoom.jpg?imwidth=230"
    },
    {
    id: 5,
    brand: "HUDA BEAUTY",
    name: "Nude Obsessions Eyeshadow Palette",
    searchTerm: "eye",
    price: 29,
    image: "https://www.sephora.com/productimages/sku/s2288090-main-zoom.jpg?imwidth=230"
    },
    {
    id: 6,
    brand: "HUDA BEAUTY",
    name: "The New Nude Eyeshadow Palette",
    searchTerm: "eye",
    price: 65,
    image: "https://www.sephora.com/productimages/sku/s2137289-main-zoom.jpg?imwidth=230"
    },
    {
    id: 7,
    brand: "Valentino",
    name: "Very Valentino 24 Hour Long Wear Liquid Foundation",
    searchTerm: "face",
    price: 67,
    image: "https://www.sephora.com/productimages/sku/s2542645-main-zoom.jpg?imwidth=230"
    },
    {
    id: 8,
    brand: "NARS",
    name: "Blush",
    searchTerm: "cheek",
    price: 17,
    image: "https://www.sephora.com/productimages/sku/s2296986-main-zoom.jpg?imwidth=230"
    },
    {
    id: 9,
    brand: "MAKEUP BY MARIO",
    name: "SoftSculpt® Transforming Skin Enhancer",
    searchTerm: "face",
    price: 30,
    image: "https://www.sephora.com/productimages/sku/s2578011-main-zoom.jpg?imwidth=230"
    },
    {
    id: 10,
    brand: "Charlotte Tilbury",
    name: "Glow Glide Face Architect Highlighter",
    searchTerm: "face",
    price: 48,
    image: "https://www.sephora.com/productimages/sku/s2643377-main-zoom.jpg?imwidth=230"
    },
    {
    id: 11,
    brand: "MAKEUP BY MARIO",
    name: "Soft Pop Blush Stick",
    searchTerm: "cheek",
    price: 30,
    image: "https://www.sephora.com/productimages/sku/s2449619-main-zoom.jpg?imwidth=230"
    },
    {
    id: 12,
    brand: "PATRICK TA",
    name: "Major Beauty Headlines - Double-Take Crème & Powder Blush",
    searchTerm: "cheek",
    price: 30,
    image: "https://www.sephora.com/productimages/sku/s2363844-main-zoom.jpg?imwidth=230"
    },
    {
    id: 13,
    brand: "LANEIGE",
    name: "Lip Glowy Balm",
    searchTerm: "lip",
    price: 17,
    image: "https://www.sephora.com/productimages/sku/s2210482-main-zoom.jpg?imwidth=230"
    },
    {
    id: 14,
    brand: "Kaja",
    name: "Eye Bento Bouncy Eyeshadow Trio",
    searchTerm: "eye",
    price: 26,
    image: "https://www.sephora.com/productimages/sku/s2594398-main-zoom.jpg?imwidth=230"
    },
    {
    id: 15,
    brand: "Rare Beauty by Selena Gomez",
    name: "Positive Light Tinted Moisturizer Broad Spectrum SPF 20 Sunscreen",
    searchTerm: "face",
    price: 30,
    image: "https://www.sephora.com/productimages/sku/s2557437-main-zoom.jpg?imwidth=230"
    },
    {
        id: 16,
        brand: "Too Faced",
        name: "Mini Secret Santa Eyeshadow",
        searchTerm: "eye",
        price: 15,
        image: "https://www.sephora.com/productimages/sku/s2612190-main-zoom.jpg?imwidth=230"
        }
    ]